import styled from 'styled-components/macro';
import { createGlobalStyle } from 'styled-components';

export const spinnerFadeDuration = 1;

export const StyledLoadingSpinner = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.white};
`;

export const StyledSpinnerContainerDrawer = styled.div<{ height?: string }>`
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: unset;
  background: #ffffff91;
  justify-content: center;
  height: ${({ height }) => `${height || '100'}%`};
`;

export const SpinnerAnimationStyles = createGlobalStyle`
  @keyframes spinner-fade {
    0% { opacity: 0.3; }
    10% { opacity: 1; }
    25% { opacity: 0.3; }
    100% { opacity: 0.3; }
  }
  .fortinet-square {
    opacity: 0.3;
    transition: opacity 0.2s linear;
  }
  .square-1 { animation: spinner-fade ${spinnerFadeDuration}s linear infinite; animation-delay: 0s; }
  .square-2 { animation: spinner-fade ${spinnerFadeDuration}s linear infinite; animation-delay: ${
  (spinnerFadeDuration / 8) * 1
}s; }
  .square-3 { animation: spinner-fade ${spinnerFadeDuration}s linear infinite; animation-delay: ${
  (spinnerFadeDuration / 8) * 2
}s; }
  .square-4 { animation: spinner-fade ${spinnerFadeDuration}s linear infinite; animation-delay: ${
  (spinnerFadeDuration / 8) * 3
}s; }
  .square-5 { animation: spinner-fade ${spinnerFadeDuration}s linear infinite; animation-delay: ${
  (spinnerFadeDuration / 8) * 4
}s; }
  .square-6 { animation: spinner-fade ${spinnerFadeDuration}s linear infinite; animation-delay: ${
  (spinnerFadeDuration / 8) * 5
}s; }
  .square-7 { animation: spinner-fade ${spinnerFadeDuration}s linear infinite; animation-delay: ${
  (spinnerFadeDuration / 8) * 6
}s; }
  .square-8 { animation: spinner-fade ${spinnerFadeDuration}s linear infinite; animation-delay: ${
  (spinnerFadeDuration / 8) * 7
}s; }
`;
